import React from "react";
import { Addon } from "components/_ProductConfigurator/SubComponents/ProductConfigurationResult/ProductResultMainView/ProductSuggestionResultView/ResultingListForm/Addons/Addons";
import { useProductConfiguratorStore } from "components/_ProductConfigurator/store/ProductConfiguratorStore";

export const ProductSuggestionAddons = () => {
  const { product } = useProductConfiguratorStore.use.productData() || {};

  return (
    <div
      className="mb-4 d-grid"
      style={{
        gridTemplateColumns: "1fr 1fr",
        gap: "1rem",
      }}
    >
      {product?.listViewConfiguration.accessories?.map((accessory, key) => (
        <Addon key={key} addonItem={accessory} />
      ))}
      {product?.listViewConfiguration.attachments?.map((attachment, key) => (
        <Addon key={key} addonItem={attachment} />
      ))}
    </div>
  );
};
